import { AppsManagementResponse, CMSResponse } from '../../types/common.type';
import {
    Injectable,
    inject,
    makeStateKey,
    TransferState,
    PLATFORM_ID,
} from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders } from '@angular/common/http';
import {
    Career,
    CareerPage,
    RecruitData,
    TitleInCareer,
} from '@shared/data/recruit.data';
import { Observable, of, tap } from 'rxjs';
import { environment } from '@environment/environment';
import { DatePipe, isPlatformServer } from '@angular/common';
import { IAppCompany, ICompaniesRecruit } from '../../types/recruit.type';
@Injectable({
    providedIn: 'root',
})
export class RecruitService extends RecruitData {
    private HttpClient = inject(HttpClient);
    private transferState = inject(TransferState);
    private platformId = inject<Object>(PLATFORM_ID);

    constructor() {
        super();
    }
    toDay = new DatePipe('en-US').transform(new Date(), 'yyyy-MM-dd');

    GetCareerPage({
        limit = '',
        offset = '',
        specializes = [],
        companies = [],
    }: {
        limit?: string | number;
        offset?: string | number;
        specializes?: any;
        companies?: any;
    }): Observable<AppsManagementResponse<CareerPage[]>> {
        const KEY = makeStateKey<AppsManagementResponse<CareerPage[]>>(
            `career-page-${limit}-${offset}-${JSON.stringify(
                specializes
            )}-${JSON.stringify(companies)}`
        );

        if (this.transferState.hasKey(KEY)) {
            const data = this.transferState.get(KEY, null!);
            this.transferState.remove(KEY);
            return of(data);
        }

        let url = `${environment.clientUrl}/careers`;

        return this.HttpClient.get<AppsManagementResponse<CareerPage[]>>(url, {
            params: {
                limit: limit,
                offset: offset,
                specializes: specializes,
                companies: companies,
            },
        }).pipe(
            tap((data) => {
                if (isPlatformServer(this.platformId)) {
                    this.transferState.set(KEY, data);
                }
            })
        );
    }

    GetDetailCareer(slug: string): Observable<CMSResponse<CareerPage>> {
        const KEY = makeStateKey<CMSResponse<CareerPage>>(
            `career-detail-${slug}`
        );

        if (this.transferState.hasKey(KEY)) {
            const data = this.transferState.get(KEY, null!);
            this.transferState.remove(KEY);
            return of(data);
        }

        let url = `${environment.clientUrl}/careers/${slug}`;
        return this.HttpClient.get<CMSResponse<CareerPage>>(url).pipe(
            tap((data) => {
                if (isPlatformServer(this.platformId)) {
                    this.transferState.set(KEY, data);
                }
            })
        );
    }

    override GetCompanies(): Observable<CMSResponse<ICompaniesRecruit[]>> {
        const KEY = makeStateKey<CMSResponse<ICompaniesRecruit[]>>('companies');

        if (this.transferState.hasKey(KEY)) {
            const data = this.transferState.get(KEY, null!);
            this.transferState.remove(KEY);
            return of(data);
        }

        let url = `${environment.clientUrl}/companies`;
        return this.HttpClient.get<CMSResponse<ICompaniesRecruit[]>>(url).pipe(
            tap((data) => {
                if (isPlatformServer(this.platformId)) {
                    this.transferState.set(KEY, data);
                }
            })
        );
    }

    override GetAppCompanies(
        slug: string
    ): Observable<CMSResponse<IAppCompany[]>> {
        const KEY = makeStateKey<CMSResponse<IAppCompany[]>>(
            `company-apps-${slug}`
        );

        if (this.transferState.hasKey(KEY)) {
            const data = this.transferState.get(KEY, null!);
            this.transferState.remove(KEY);
            return of(data);
        }

        let url = `${environment.clientUrl}/company/${slug}/apps`;
        return this.HttpClient.get<CMSResponse<IAppCompany[]>>(url).pipe(
            tap((data) => {
                if (isPlatformServer(this.platformId)) {
                    this.transferState.set(KEY, data);
                }
            })
        );
    }
}
